// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__2eywN","spin":"Spinner_spin__l9woc","sm":"Spinner_sm__+OXY0","wrap":"Spinner_wrap__f+Deo"};